/**
 * Resolves API base URLs for dev-only shortcuts (e.g. the /dev/token endpoint).
 *
 * Production ClinicMgmt traffic goes through slv2 runtime config
 * (config.ts -> AppConfig.apiBase); these helpers are retained only for
 * callers that run before loadConfig() completes or in sandbox flows.
 *
 * Priority order for getApiBaseUrl():
 *   1. window.__RUNTIME_CONFIG__?.API_URL  (runtime-injected override)
 *   2. import.meta.env.VITE_API_BASE_URL   (Vite build-time env variable)
 *   3. Hardcoded localhost fallback
 *
 * The other getters (auth / authv2 / accountsV2) use only steps 2 and 3.
 */
export function getApiBaseUrl(): string {
  const runtimeUrl = window.__RUNTIME_CONFIG__?.API_URL;
  if (runtimeUrl) {
    return runtimeUrl;
  }
  return (import.meta.env.VITE_API_BASE_URL as string | undefined) || 'http://localhost:5001/api';
}

export function getAuthBaseUrl(): string {
  return (import.meta.env.VITE_AUTH_BASE_URL as string | undefined) || 'http://localhost:5001/api/identity';
}

export function getAuthV2BaseUrl(): string {
  return (import.meta.env.VITE_AUTH_V2_BASE_URL as string | undefined) || 'http://localhost:5001/api/identity/v2';
}

export function getAccountsV2BaseUrl(): string {
  return (import.meta.env.VITE_ACCOUNTS_V2_BASE_URL as string | undefined) || 'http://localhost:5001/api/accounts/v2';
}
